import { useLocation } from "react-router-dom";
import usePageTitle from "../../utils/hooks/usePageTitle";
import ForgotPassword from "../../components/authentication/ForgotPassword";
import ResetPasswordForm from "../../components/authentication/ResetPasswordForm";

const ResetPassword = () => {
  // Retrieve the email and/or reset token from the URL
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const email = params.get("email");
  const token = params.get("token");

  usePageTitle("Reset Password");

  return email != null && token != null ? (
    <ResetPasswordForm email={email} token={token} />
  ) : (
    <ForgotPassword />
  );
};

export default ResetPassword;
